import { FilterTile } from "components/ui/filter-tile";
import React from "react";
import { GoalColumnIcon } from "./goal-column-icons";
import { MetricBar } from "./metric-bar";

interface GoalFilterTileProps {
    icon: GoalColumnIcon;
    label: string;
    barColor: string;
    actual: number;
    target: number;
    frac: number;
    footer: React.ReactNode;
    selected: boolean;
    onToggle: () => void;
}

export const GoalFilterTile: React.FC<GoalFilterTileProps> = ({
    icon: Icon,
    label,
    barColor,
    actual,
    target,
    frac,
    footer,
    selected,
    onToggle,
}) => (
    <FilterTile
        icon={className => <Icon aria-hidden="true" className={className} />}
        label={label}
        hint={null}
        count={actual}
        countSuffix={<span className="text-xs text-gray-500">/ {target}</span>}
        meter={
            <MetricBar
                actual={actual}
                target={target}
                bar={barColor}
                frac={frac}
                height="h-1.5"
            />
        }
        footer={footer}
        selected={selected}
        onToggle={onToggle}
    />
);
